import { render, staticRenderFns } from "./TransfertGainsModal.vue?vue&type=template&id=dbd1e4ba&scoped=true&"
import script from "./TransfertGainsModal.vue?vue&type=script&lang=js&"
export * from "./TransfertGainsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd1e4ba",
  null
  
)

export default component.exports